import { createContext } from "react-router";
import type { AppStore } from "@/store/app/storeTypes";

export const AppStoreRouterContext = createContext<AppStore>();
